import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { WELCOME_TEXT } from '../../constants';
import { EYE_OPS_IMAGE_PATH } from '../../constants';
import { IRegistrationComponentProps } from '../../constants/types';
import theme from '../../theme';
import FrameImg from '/images/frameImg.svg';

const RegistrationComponent: React.FC<IRegistrationComponentProps> = ({
  onEnter,
}) => {
  return (
    <>
      <img
        width={'100%'}
        style={{ flexGrow: 1, objectFit: 'cover' }}
        alt="Frame"
        src={FrameImg}
      ></img>
      <Box
        sx={{ background: theme.palette?.bg?.main, p: 3, flexGrow: 1 }}
        className="d-flex flex-column align-items-center justify-content-end flex-1"
      >
        <img
          src={EYE_OPS_IMAGE_PATH}
          style={{ alignSelf: 'start' }}
          alt="Profile"
          loading="lazy"
        />
        <Typography
          variant="h4"
          color="primary"
          mt={6}
          mb={2}
          textAlign="center"
        >
          {WELCOME_TEXT}
        </Typography>
        <Typography variant="body1" mb={6} textAlign="center">
          Use this platform to send information to your clinical team, access
          health content, and get eye health support.
        </Typography>
        <Box sx={{ mb: 4.5, width: '100%' }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ mb: 1.5 }}
            onClick={onEnter}
            fullWidth
          >
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default RegistrationComponent;
